import { useCreateVenueOverviewVersion } from '@api';
import { useNotification } from '@common';
import { useRouter } from '@tanstack/react-router';
import { AxiosError } from 'axios';

const TRANS_KEY = 'NOTIFICATIONS.ADD_VERSION';

export type AddVersionArgsType = {
  newVersion: string;
};

type UseAddOverviewVersionReturnType = {
  addVersion: (data: AddVersionArgsType) => Promise<void>;
};

export const useAddOverviewVersion = ({
  venueId,
}: {
  venueId: string;
}): UseAddOverviewVersionReturnType => {
  const { mutateAsync } = useCreateVenueOverviewVersion();
  const { showError, showSuccess } = useNotification();
  const router = useRouter();

  const onSuccess = (newVersion: string) => {
    showSuccess({
      title: `${TRANS_KEY}.SUCCESS.TITLE`,
      message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
    });
    router.navigate({
      to: '/venues/$id/overview/$version',
      params: { id: venueId, version: newVersion },
    });
  };

  const onError = (error: AxiosError) => {
    showError({
      title: `${TRANS_KEY}.ERROR.TITLE`,
      message: `${TRANS_KEY}.ERROR.MESSAGE`,
      error: error,
    });
  };

  const addVersion = async ({ newVersion }: AddVersionArgsType) => {
    await mutateAsync(
      {
        venueId,
        data: { data: newVersion },
      },
      {
        onSuccess: () => onSuccess(newVersion),
        onError,
      }
    );
  };

  return { addVersion };
};
